import {
  AmplifyAuthenticator,
  AmplifySignIn,
  AmplifyAuthContainer
} from "@aws-amplify/ui-react";
import {
  Box,
  Spinner,
  Image
} from "@chakra-ui/react";
import React from "react";
import {
  RouteComponentProps,
  useHistory
} from "react-router-dom";

import { useAuthContext } from "src/hooks/useAuthContext";
import { Text } from "src/components/text";
import { theme } from "src/components/theme";

type LoginPageProps = RouteComponentProps<
  undefined,
  Record<string, unknown>,
  { from: string }
>;

export const LoginPage: React.FC<LoginPageProps> = ({ location }) => {
  const { authDataState } = useAuthContext();
  const history = useHistory();

  React.useEffect(() => {
    if (authDataState.authenticated) {
      // redirect to previous page, otherwise home page
      history.push(location?.state?.from || "/");
    }
  }, [
    history,
    authDataState,
    location
  ]);

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        w="100%"
        mb={5}
        flexDirection="column"
      >
        <Image
          mt="20vh"
          w={20}
          h={20}
          src="braided-logo.svg"
        />

        <Text as="h4">
          Braided Communications
        </Text>
      </Box>

      <AmplifyAuthContainer>
        <AmplifyAuthenticator
          style={{
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - these properties are allowed
            "--container-height": "50vh",
            "--amplify-font-family": "europa, Roboto, Arial",
            "--amplify-primary-color": theme.colors.main,
            "--amplify-primary-tint": "#A0AEC0",
            "--amplify-primary-shade": "#4A5568"
          }}
        >

          <AmplifySignIn
            headerText="Login to continue"
            slot="sign-in"
            hideSignUp
            formFields={[ { type: "username" }, { type: "password" } ]}
          >
            <Spinner
              slot="loading"
            />

            <div slot="federated-buttons" />

            <div slot="amplify-button" />
          </AmplifySignIn>
        </AmplifyAuthenticator>
      </AmplifyAuthContainer>
    </Box>
  );
};
